import Header from "../component-library/template-components/header/header.js";
import Modal from "../component-library/elements/modal/modal.js";

const Factory = {
  ".js-Header": Header,
  ".js-Modal": Modal,
};

Object.keys(Factory).forEach((key) => {
  Array.from(document.querySelectorAll(key)).map(
    (element) => new Factory[key](element),
  );
});
